module.exports = __webpack_public_path__ + "img/zoom_in.a26d8d42.svg";